export default class TextFormat {
    /**
     * @param {string} id
     * @param {string|number} value
     */
    static addFormatVar(id, value) {
        this._formatVars[id] = value;
    }

    /**
     * @param {string} id
     */
    static removeFormatVar(id) {
        delete this._formatVars[id];
    }

    static removeAllFormatVars() {
        this._formatVars = {};
    }

    /**
     * @param {string} text
     * @return {string}
     */
    static formatText(text) {
        for (const i in this._formatVars) {
            if (this._formatVars.hasOwnProperty(i)) {
                const value = this._formatVars[i];
                text = text.replace(/{ + i + }/g, value + "");
            }
        }
        return text;
    }

    /**
     * @param {string} text
     * @param {string} id
     * @param {string|number} value
     */
    static formatTextVar(text, id, value) {
        return text.replace(/{ + id + }/g, value + "");
    }
}

TextFormat._formatVars = {};